import $ from 'jquery';

import L from 'leaflet/dist/leaflet';
import mapboxgl from 'mapbox-gl';

export function leaflet_init(classes = ".our-map") {
  if ($(classes).length > 0) {
    $(classes).each(function () {
      var marker = "";
      var oMap = $(this);
      var idMap = $(this).attr('id');
      var markers = [];
      var latN = "";
      var lngN = "";
      var zoom = $(this).data('zoom');
      var icon = $(this).data('icon');
      var shadowIcon = $(this).data('shadow-icon');
      var description = "";
      var icoWidth = $(this).data('icowidth');
      var icoHeight = $(this).data('icoheight');
      var icoAnchorLeft = "";
      var icoAnchorRight = "";
      var main_LatN = $(this).data('center-lat');
      var main_lngN = $(this).data('center-lng');
      var flys = [];
      var myMap = L.map(idMap);

      // load a tile layer
      /*
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(myMap);

https://api.mapbox.com/styles/v1/quentinba/cl7qc91vh004b15ry8i8vywqx/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoicXVlbnRpbmJhIiwiYSI6ImNqbXZ1aW14cjE0aXQzd3F5a2lqaDhoM2wifQ.vX53O4Vt0MBLV0PaXstvgQ
    */
    mapboxgl.accessToken = 'pk.eyJ1IjoicXVlbnRpbmJhIiwiYSI6ImNqbXZ1aW14cjE0aXQzd3F5a2lqaDhoM2wifQ.vX53O4Vt0MBLV0PaXstvgQ';
    L.tileLayer(
      'https://api.mapbox.com/styles/v1/quentinba/cl7qceumk000w14r21elzbhlr/tiles/256/{z}/{x}/{y}@2x?access_token=' + mapboxgl.accessToken
      , {
        tileSize: 512,
        zoomOffset: -1,
        attribution: '© <a href="https://www.mapbox.com/contribute/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(myMap);

      oMap.find('.woody-marker').each(function () {
        var icon = $(this).data('icon');
        latN = Number($(this).data('map-lat'));
        lngN = Number($(this).data('map-lng'));
        zoom = Number($(this).data('map-zoom'));
        description = $(this).data('map-description');
        if ($(this).data('map-main') == '1') {
          main_LatN = Number($(this).data('map-lat'));
          main_lngN = Number($(this).data('map-lng'));
        }
        if (latN !== "" && lngN !== "") {
          var myIcon = L.icon({
            iconUrl: icon,
            iconSize:     [40, 41],
            iconAnchor:   [20, 41],
          });
          var marker = L.marker([latN, lngN], {icon: myIcon}).addTo(myMap);
        }
      });

      myMap.scrollWheelZoom.disable();
      myMap.setView([main_LatN, main_lngN], zoom);
      $(classes).find("a").addClass('nude');
    });
  }
}
$(document).ready(function () {
  leaflet_init();
});
